import { BasicAddEditConfig } from './BasicAddEditConfig'

export default class BasicAddEditHelpers {
    createTableConfigDataResonseModel = (dataResonseModel) => {
        var data = [];
        //console.log(dataResonseModel);
        if (dataResonseModel !== undefined && dataResonseModel.rows === undefined) {
           // console.log('TableData IEnumereable')
            data = dataResonseModel.map(row => {
                let tableRow = {}
                dataResonseModel.columnIds.forEach(col => tableRow[col] = row[col])

                return tableRow
            });
        }
        else if (dataResonseModel !== undefined && dataResonseModel.rows !== undefined) {
            //console.log('TableData rows dataset')
            data = dataResonseModel.rows.map(row => {
                let tableRow = {}
                dataResonseModel.columnIds.forEach((col, index) => tableRow[col] = row[index])
                return tableRow;
            });
        }

        return {
            tableData: data,
            tableColumns: dataResonseModel.columns,
            tableColumnIds: dataResonseModel.columnIds,
            handleRowClick: () => { }
        }
    }

    createTableConfig = (tableData, tableColumns, tableColumnIds) => {
        var data = [];
        if (tableData !== undefined && tableData.rows === undefined) {
            //console.log('TableData IEnumereable')
            data = tableData.map(row => {
                let tableRow = {}
                tableColumnIds.forEach(col => tableRow[col] = row[col])

                return tableRow
            });
        }
        else if (tableData !== undefined && tableData.rows !== undefined) {
            //console.log('TableData rows dataset')
            data = tableData.rows.map(row => {
                    let tableRow = {}
                    tableColumnIds.forEach((col, index) =>  tableRow[col] = row[index])
                        return tableRow;
                });
        }
        
        return {
            tableData: data,
            tableColumns: tableColumns,
            tableColumnIds: tableColumnIds,
            handleRowClick: () => { }
        }
    }

    handleSelectChange = (setState, event) => {
        const fieldId = event.target.id
        let updatedStateItem = { item: BasicAddEditConfig.scenarioFieldsModel }
        updatedStateItem.item[fieldId] = event.target.selectedOptions[0].id
        setState(prevState => {
            return {
                ...prevState,
                ...updatedStateItem
            }
        })
    }

    handleInputChange = (setState, event) => {
        const fieldId = event.target.id
        let updatedStateItem = { item: BasicAddEditConfig.scenarioFieldsModel }
        updatedStateItem.item[fieldId] = event.target.value
        setState(prevState => {
            return {
                ...prevState,
                ...updatedStateItem
            }
        })
    }

    createAddEditFields = (fieldData, setState, stateItem) => {
        const textAreaStyle = { resize: 'none', height: '4rem' }
        return fieldData.map((field, index) => {
            if (field.type === 'select') {
                return (
                    <span key={index} className='add-edit-field'>
                        <label>{field.name}</label>
                        <select className='add-edit-input' onChange={e => this.handleSelectChange(setState, e)} id={field.id} value={stateItem[field.id]} disabled={!field.editable}>
                            {
                                field.options.map((option, index) => {
                                    return (
                                        <option key={index} id={option.optionId} name={option.optionId} value={option.id}>{option.name}</option>
                                    )
                                })
                            }
                        </select>
                    </span>
                )
            } else if (field.type === 'textarea') {
                return (
                    <span key={index} className='add-edit-field'>
                        <label>{field.name}</label>
                        <textarea
                            className='add-edit-input'
                            rows={4}
                            cols={50}
                            name={field.id}
                            id={field.id}
                            onChange={e => this.handleInputChange(setState, e)}
                            value={stateItem ? stateItem[field.id] : ''}
                            style={field.type === 'textarea' ? textAreaStyle : {}}>
                        </textarea>
                    </span>
                )
            } else if (!field.editable) {
                return (
                    <span key={index} className='add-edit-field'>
                        <label>{field.name}</label>
                        <input
                            className='add-edit-input'
                            type={field.type}
                            id={field.id}
                            name={field.id}
                            value={stateItem ? stateItem[field.id] : ''}
                            disabled />
                    </span>
                )
            } else {
                return (
                    <span key={index} className='add-edit-field'>
                        <label>{field.name}</label>
                        <input
                            className='add-edit-input'
                            type={field.type}
                            id={field.id}
                            onChange={e => this.handleInputChange(setState, e)}
                            name={field.id} value={stateItem ? stateItem[field.id] : ''}
                            value={stateItem ? stateItem[field.id] : ''}
                            style={field.type === 'textarea' ? textAreaStyle : {}} />
                    </span>
                )
            }
        })
    }

    handleRowClick = (setAddEdit, setState, tableRow) => {
        setAddEdit(true)
        setState(prevItem => { return { ...prevItem, ...{ item: tableRow } } })
    }
}